import Cookies from 'js-cookie';

import { environment } from '../environment/environment';

export const removeCookies = () => {
  const [_subdomain, rootDomain, topLevelDomain] = location.hostname.split('.');
  const CookiesAPI = Cookies.withAttributes({ path: '/', domain: `.${rootDomain}.${topLevelDomain}` });
  const names = Object.keys(CookiesAPI.get());
  for (const name of names) {
    CookiesAPI.remove(name);
  }
};

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const hostname = environment.hostname || new URL(window.location.origin).hostname;
export const isAdminSubDomain = hostname.includes('admin');
export const isOlhDomain = hostname.includes('ontariolegionhealth');

const getBaseEndpoint = (endpoint: string) => (isAdminSubDomain ? endpoint.replace('clinician', 'admin') : endpoint);

export const BASE_ENDPOINT = {
  CA: getBaseEndpoint(environment.CAEndpoint),
  US: getBaseEndpoint(environment.USEndpoint),
};

export const US_REGION = `us-${environment.environment_deploy}`;

// Antd Form.Item stores whatever an input's onChange reports; a cleared field reports "",
// which should usually be treated as "no value" (null) rather than an empty string.
export const emptyToNull = (value: string): string | null => value || null;
